import { useState } from "react";
import type { ItemSpan } from "@keydials/api-client";
import { spanFromForm } from "./daySpan";

const field: React.CSSProperties = {
  font: "inherit",
  fontSize: 13,
  padding: "5px 8px",
  borderRadius: "var(--radius-sm)",
  border: "var(--border-w) solid var(--border)",
  background: "var(--surface)",
  color: "var(--text)",
};

/**
 * KEY-859: when something on a day happens — all day, or from a time until a time. Something that takes time counts in
 * every part of the day it covers; a start on its own is just when it is.
 */
export function DaySpanEditor({ span, onSave }: { span: ItemSpan | null | undefined; onSave: (span: ItemSpan | null) => void }) {
  const [allDay, setAllDay] = useState(!!span?.allDay);
  const [start, setStart] = useState(span?.startsAt ?? "");
  const [end, setEnd] = useState(span?.endsAt ?? "");
  const next = spanFromForm(allDay, start, end);
  const unchanged =
    next !== "invalid" &&
    !!next?.allDay === !!span?.allDay &&
    (next?.startsAt ?? null) === (span?.startsAt ?? null) &&
    (next?.endsAt ?? null) === (span?.endsAt ?? null);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 12.5, color: "var(--text-muted)" }}>
      <span style={{ minWidth: 92 }}>Time</span>
      <label style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
        <input type="checkbox" checked={allDay} onChange={(e) => setAllDay(e.target.checked)} />
        All day
      </label>
      {!allDay && (
        <>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
            From
            <input type="time" aria-label="From" value={start} onChange={(e) => setStart(e.target.value)} style={field} />
          </label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
            until
            <input type="time" aria-label="Until" value={end} onChange={(e) => setEnd(e.target.value)} style={field} />
          </label>
        </>
      )}
      <button
        type="button"
        className="kd-btn kd-btn-sm"
        disabled={next === "invalid" || unchanged}
        onClick={() => next !== "invalid" && onSave(next)}
      >
        Save time
      </button>
      {next === "invalid" && <span role="alert" style={{ color: "var(--danger, #b42318)" }}>The end has to be after the start.</span>}
    </div>
  );
}
